
interface IConf {
  build: string,
  redirect_uri: string,
  uri_basename: string,
  oidc_callback_redirect: string
}

export let conf: IConf = {
  build: 'prod',
  oidc_callback_redirect: "/",
  redirect_uri: `${window.location.protocol}//${window.location.hostname}/index.html?oidc=signed-in`,
  uri_basename: '/'
}

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  conf.build = 'dev'
  conf.oidc_callback_redirect = '/generators'
  conf.redirect_uri = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/index.html?oidc=signed-in`,
  conf.uri_basename = ''
}



// WEBPACK FOOTER //
// ./src/constants/config/configVars.ts